import { FC } from 'react';
import styled from 'styled-components';
import { StyledSection } from '../../styles/section.styled';
import { Container } from '../../styles/container.styled';
import { StyledTitle } from '../../styles/title.styled';
import { partners } from './partners.constants';

const Partners: FC = () => {
    return (
        <StyledPartners id="partners">
            <StyledSection>
                <Container>
                    <StyledTitle>Наши партнеры</StyledTitle>
                    <StyledList>
                        {partners.map((item) => (
                            <StyledItem key={item.title}>
                                <StyledImageWrapper>
                                    <img src={item.img} alt={item.title} />
                                </StyledImageWrapper>
                                <StyledInfo>
                                    <h4>{item.title}</h4>
                                    <StyledLinkHref
                                        href={item.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {item.url}
                                    </StyledLinkHref>
                                    <p>{item.text}</p>
                                </StyledInfo>
                            </StyledItem>
                        ))}
                    </StyledList>
                </Container>
            </StyledSection>
        </StyledPartners>
    );
};

const StyledPartners = styled.div`
    padding-top: 80px;
    @media (max-width: 768px) {
        padding-top: 32px;
    }
`;

const StyledList = styled.div`
    margin-top: 40px;
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

const StyledItem = styled.div`
    display: flex;
    align-items: center;
    gap: 30px;
    padding: 24px 0;
    background: #ffffff;
    box-shadow: var(--shadow-main);
    border-radius: 8px;
    @media (max-width: 768px) {
        flex-direction: column;
        padding: 16px;
    }
`;

const StyledImageWrapper = styled.div`
    width: 415px;
    max-width: 100%;
    height: 180px;
    padding: 0 24px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
        width: 100%;
        height: auto;
        border-radius: 4px;
        display: block;
        object-fit: contain;
    }

    @media (max-width: 768px) {
        width: 100%;
        height: auto;
    }
`;

const StyledInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding-right: 24px;
    width: 100%;
    h4 {
        margin: 0;
        font-size: 20px;
        font-weight: 700;
        line-height: 120%;
        color: var(--color-text-main);
    }
    p {
        margin: 0;
        font-size: 16px;
        line-height: 135%;
        color: var(--color-text-main);
    }

    @media (max-width: 768px) {
        padding: 0 24px 16px 24px;
    }
`;

const StyledLinkHref = styled.a`
    font-size: 16px;
    line-height: 135%;
    color: var(--color-primary-blue);
    text-decoration: underline;
`;

export default Partners;


